import React from "react";
import {
  SkillsContainer,
  SkillsPaper,
  SkillsTitle,
  SkillsDescription,
  IconWrap,
  SkillsHeaderWrap,
  SkillsHeader,
} from "./StyledSkillsSection";
import { skillsData } from "./skillsData";
import { Grid } from "@mui/material";

function SkillsSection() {
  return (
    <SkillsContainer
      container
      justifyContent="center"
      alignItems="center"
      id="skills"
    >
      <SkillsHeaderWrap
        container
        item
        direction="column"
        justifyContent="center"
        alignContent="center"
      >
        <SkillsHeader>My Awsome Skills</SkillsHeader>
      </SkillsHeaderWrap>
      {skillsData.map((skill, index) => (
        <Grid
          container
          item
          lg={3}
          md={3}
          xs={6}
          key={index}
          justifyContent="center"
          alignItems="center"
        >
          <SkillsPaper elevation={12}>
            <IconWrap container>{skill.icon}</IconWrap>
            <SkillsTitle>{skill.title}</SkillsTitle>
            <SkillsDescription>{skill.description}</SkillsDescription>
          </SkillsPaper>
        </Grid>
      ))}
    </SkillsContainer>
  );
}

export default SkillsSection;
